import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { deepCopy } from '../../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { tags } from '../../../../../../redux/tags/action';
import { selectTagsListItems } from '../../../../../../redux/tags/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import { customers } from '../../../../../../redux/customers/action';
import { shippingProviders } from '../../../../../../redux/shipping-providers/action';
import { selectShippingProvidersListItems } from '../../../../../../redux/shipping-providers/selector';
import { measureDimensions } from '../../../../../../redux/measure-dimensions/action';
import { measureWeights } from '../../../../../../redux/measure-weights/action';
import { selectMeasureDimensionsListItems } from '../../../../../../redux/measure-dimensions/selector';
import { selectMeasureWeightsListItems } from '../../../../../../redux/measure-weights/selector';
import RateCardComponent from '../components/rate-card.component';
import { selectShippingTypesListItems } from '../../../../../../redux/shippingTypes/selector';
import { selectPinCodesListItems } from '../../../../../../redux/pin-codes/selector';
import { selectRateCardQueryItems } from '../../../../../../redux/rate-cards/selector';
import { rateCards } from '../../../../../../redux/rate-cards/action';
import { pinCodes } from '../../../../../../redux/pin-codes/action';
import { shippingTypes } from '../../../../../../redux/shippingTypes/action';
import Popup from '../../../../../../common/components/popup';
import ModalRateCardRuleComponent from '../components/rate-card-rules.component';
import { selectVehicleCategoriesListItems } from '../../../../../../redux/vehicle-categories/selector';
import { vehicleCategories } from '../../../../../../redux/vehicle-categories/action';
import { selectVehiclesListItems } from '../../../../../../redux/vehicles/selector';
import { vehicles } from '../../../../../../redux/vehicles/action';


let currentChange: any = {}

type TaxonomyDetails = {
  LogisticsCategoryVehicleId: any
  VehicleIds: [],
  DistanceUnitId: any,
  MinimumDistance: any,
  MaximumDistance: any,
  DistanceIncrement: any,
  DistanceIncrementCharge: any
};

const RateCard = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [taxonomy, setTaxonomy] = useState<TaxonomyDetails[]>([]);
  const [columnDefs, setColumnDefs] = useState({});
  const [selectLogistics, setSelectedLogistics] = useState<any>([])
  const [addItem, setAddItem] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const shippingProvidersLists = useSelector(selectShippingProvidersListItems)
  const shippingTypesLists = useSelector(selectShippingTypesListItems)
  const measureDimensionsLists = useSelector(selectMeasureDimensionsListItems)
  const measureWeightLists = useSelector(selectMeasureWeightsListItems)
  const customerLists = useSelector(selectCustomersListItems)
  const pinCodesLists = useSelector(selectPinCodesListItems)
  const vehicleCategoriesListItems = useSelector(selectVehicleCategoriesListItems)
  const queryItems = useSelector(selectRateCardQueryItems)
  const vehiclesListItems = useSelector(selectVehiclesListItems)
  const [selectedRateCardValues, setSelectedRateCardValues] = useState([]);
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedRateCards,
    setSelectedRateCards
  ] = useState<any>([])
  const [
    categoryImageIndex,
    setRateCardImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);


  const fetchQueryById = () => {
    dispatch(rateCards.query({
      url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/rate-cards/query`, entity: 'hsCodes', jsonData: {
        Context: {},
        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedRateCards({ ...selectedRateCards, [field]: event })
    setSelectedLogistics({ ...selectLogistics, [field]: event })
  }
  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedRateCards({ ...selectedRateCards, [fields[0]]: valueData });
  }
  const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(
    () => {
      createColumnDefs()
      dispatch(tags.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tags',
        jsonData: {}

      })).then(() => {
        dispatch(vehicles.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`,
          entity: 'vehicles',
          jsonData: {}
        }));
      })
        .then(() => {
          dispatch(customers.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`,
            entity: 'customers',
            jsonData: {}
          }));
        }).then(() => {
          dispatch(vehicleCategories.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/list`, entity: 'vehicleCategory', jsonData: {

            }
          }))
        }).then(() => {
          dispatch(shippingProviders.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`,
            entity: 'shippingProviders',
            jsonData: {}
          }));
        }).then(() => {
          dispatch(measureDimensions.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/list`,
            entity: 'measureDimensions',
            jsonData: {}
          }))
        }).then(() => {
          dispatch(measureWeights.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/list`,
            entity: 'measureWeights',
            jsonData: {}
          }))
        }).then(() => {
          dispatch(pinCodes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes/list`,
            entity: 'pincodes',
            jsonData: {}
          }))
        }).then(() => {
          dispatch(shippingTypes.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`,
            entity: 'shippingTypes',
            jsonData: {}
          }));
        })
        .then(() => {
          if (parmas?.id > 0) {
            fetchQueryById()

          } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
            // const localSelectedDsiscounts = addNewRateCardValuesRow({ selectedRateCardValuesArg: selectedRateCardValues });
            // setSelectedRateCardValues(localSelectedDsiscounts)
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        const querydata: any = queryItems?.result?.items
        setSelectedRateCards({
          Id: querydata?.Id,
          IsActive: querydata?.IsActive,
          Name: querydata?.Name,
          Description: querydata?.Description,
          LogisticsProviderId: querydata?.LogisticsProviderId,
          StartDateUtc: querydata?.StartDateUtc,
          EndDateUtc: querydata?.EndDateUtc,
          Remarks: querydata?.Remarks,
          LogisticsOrderType: querydata?.LogisticsOrderType,
          DisplayOrder: querydata?.DisplayOrder,
          Exclusions: querydata?.Exclusions,
          Inclusions: querydata?.Inclusions,
          Logisticss: querydata?.Logisticss,
          MediaMappings: querydata?.MediaMappings,
          PINCode: querydata?.Logisticss[0]?.PINCode?.PinCode

        })
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
        const logisticsItemsData: any = queryItems?.result?.items?.Logisticss.map((item: any) => {

          const itemData = {
            Id: item?.Id,
            EntityTypeId: item?.EntityTypeId,
            EntityId: item?.EntityId,
            ShippingTypeId: item?.ShippingTypeId,
            AverageDeliveryTime: item?.AverageDeliveryTime,
            ShippingTypePreferenceId: item?.ShippingTypePreferenceId,
            Name: item?.Name,
            DurationUnitId: item?.TimeSlot?.DurationUnitId,
            Duration: item?.TimeSlot?.Duration,
            DurationIncrement: item?.TimeSlot?.DurationIncrement,
            PickupTimeSlots: item?.TimeSlot?.PickupTimeSlots,
            DeliveryTimeSlots: item?.TimeSlot?.DeliveryTimeSlots,
            MinimunDistance: item?.Shipping?.MinimunDistance,
            MaximumDistance: item?.Shipping?.MaximumDistance,
            DistanceUnitId: item?.Shipping?.DistanceUnitId,
            MinimumWeight: item?.Shipping?.MinimumWeight,
            MaximumWeight: item?.Shipping?.MaximumWeight,
            WeightUnitId: item?.Shipping?.WeightUnitId,
            PackageSizeUnit: item?.Shipping?.PackageSizeUnit,
            MinimumHeight: item?.Shipping?.MinimumHeight,
            MaximumHeight: item?.Shipping?.MaximumHeight,
            MinimumLength: item?.Shipping?.MinimumLength,
            MaximumLength: item?.Shipping?.MaximumLength,
            MinimumBreadth: item?.Shipping?.MinimumBreadth,
            MaximumBreadth: item?.Shipping?.MaximumBreadth,
            DistanceIncrement: item?.Shipping?.DistanceIncrement,
            DistanceIncrementCharge: item?.Shipping?.DistanceIncrementCharge,
            WeightIncrement: item?.Shipping?.WeightIncrement,
            WeightIncrementCharge: item?.Shipping?.WeightIncrementCharge,
            DeliveryCharge: item?.Shipping?.DeliveryCharge,
            FuelCharge: item?.Shipping?.FuelCharge,
            WaitingCharge: item?.Shipping?.WaitingCharge,
            PeakSeasonCharge: item?.Shipping?.PeakSeasonCharge,
            TollCharge: item?.Shipping?.TollCharge,
            RTOCharge: item?.Shipping?.RTOCharge,
            IsIncludeVehicleAmount: item?.Shipping?.IsIncludeVehicleAmount,
            LogisticsCategoryVehicleDistanceInfo: item?.Shipping?.LogisticsCategoryVehicleDistanceInfo
          }
          return itemData
        })
        setSelectedRateCardValues(logisticsItemsData)

      }
    },
    [isQuery]
  )



  const back = () => {
    navigate('/management/policy/shipment/rate-cards')
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 152,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setRateCardImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'logisticspolicy',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }



  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setMediaInfo()
      }
    },
    [mediaFiles]
  )

  //Save the modal data function
  const handleSaveItem = async (data: any) => {

  }
  // Add button
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add RateCard Rules</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAddItem(),
    }
  ];

  //Table ColumnDef Function
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name' },
      { field: 'PickupTimeSlots', headerName: 'Pickup Time Slots' },
      { field: 'MaximumDistance', headerName: 'Maximum Distance', },
      { field: 'MaximumWeight', headerName: 'Maximum Weight' },

    ]);
  }

  //Add the data in the Table Function
  const handleAddItem = () => {
    setAddItem({
      id: 0
    });
  }

  //Table Edit Function
  const handleEdit = (itemData: any) => {
    setAddItem({
      id: itemData.id
    })
    setSelectedLogistics(itemData)
    setTaxonomy(itemData?.LogisticsCategoryVehicleDistanceInfo)

  }

  //Table Delete Function
  const handleDelete = (data: any) => {
    setSelectedRateCardValues((prevState: any) =>
      prevState.filter((item: any) => item?.Id !== data?.Id)
    );

  };

  //Modal Close Function
  const closeModal = () => {
    setAddItem(undefined)
    setSelectedLogistics([])
    setTaxonomy([])
  }

  // Modal Function
  const NewItemPopup = ({ handleSaveItem }: any) => {
    const [localItems, setLocalItems] = useState(deepCopy(selectLogistics));
    const [localTaxonomyItems, setLocalTaxonomyItems] = useState(deepCopy(taxonomy));
    const handleLocalFormChange = (value: any, field: any) => {
      setLocalItems((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    };

    const handleItemSubmit = async () => {


      const data = {
        Id: localItems?.Id ? localItems?.Id : 0,
        EntityTypeId: localItems?.EntityTypeId,
        EntityId: localItems?.EntityId,
        ShippingTypeId: localItems?.ShippingTypeId,
        AverageDeliveryTime: localItems?.AverageDeliveryTime,
        ShippingTypePreferenceId: localItems?.ShippingTypePreferenceId,
        Name: localItems?.Name,
        DurationUnitId: localItems?.DurationUnitId,
        Duration: localItems?.Duration,
        DurationIncrement: localItems?.DurationIncrement,
        PickupTimeSlots: localItems?.PickupTimeSlots,
        DeliveryTimeSlots: localItems?.DeliveryTimeSlots,
        MinimunDistance: localItems.MinimunDistance,
        MaximumDistance: localItems?.MaximumDistance,
        DistanceUnitId: localItems?.DistanceUnitId,
        MinimumWeight: localItems?.MinimumWeight,
        MaximumWeight: localItems?.MaximumWeight,
        WeightUnitId: localItems?.WeightUnitId,
        PackageSizeUnit: localItems?.PackageSizeUnit,
        MinimumHeight: localItems?.MinimumHeight,
        MaximumHeight: localItems?.MaximumHeight,
        MinimumLength: localItems?.MinimumLength,
        MaximumLength: localItems?.MaximumLength,
        MinimumBreadth: localItems?.MinimumBreadth,
        MaximumBreadth: localItems?.MaximumBreadth,
        DistanceIncrement: localItems?.DistanceIncrement,
        DistanceIncrementCharge: localItems?.DistanceIncrementCharge,
        WeightIncrement: localItems?.WeightIncrement,
        WeightIncrementCharge: localItems?.WeightIncrementCharge,
        DeliveryCharge: localItems?.DeliveryCharge,
        FuelCharge: localItems?.FuelCharge,
        WaitingCharge: localItems?.WaitingCharge,
        PeakSeasonCharge: localItems?.PeakSeasonCharge,
        TollCharge: localItems?.TollCharge,
        RTOCharge: localItems?.RTOCharge,
        IsIncludeVehicleAmount: localItems?.IsIncludeVehicleAmount,
        LogisticsCategoryVehicleDistanceInfo: localTaxonomyItems

      }
      await setSelectedRateCardValues((prevState: any) => {
        // Check if the item exists by Name
        const exists = prevState.some((item: any) => item.Name == data.Name);
        // If it exists, update it, otherwise add the new item
        return exists
          ? prevState.map((item: any) => item.Name == data.Name ? data : item)
          : [...prevState, data];
      });

      await closeModal();
    };

    const handleTaxonomyFormChange = (index: number, key: keyof TaxonomyDetails, value: any) => {
      setLocalTaxonomyItems((prev) =>
        prev.map((v, i) => (i === index ? { ...v, [key]: value } : v))
      );
    };

    const removeTaxonomy = (index: number) => {
      setLocalTaxonomyItems((prev) => prev.filter((_, i) => i !== index));
    };
    const addTaxonomyRow = () => {
      setLocalTaxonomyItems((prev) => [
        ...prev,
        {
          LogisticsCategoryVehicleId: 0,
          VehicleBodyTypeId: 0,
          VehicleIds: [],
          DistanceUnitId: 0,
          MinimumDistance: 0,
          MaximumDistance: 0,
          DistanceIncrement: 0,
          DistanceIncrementCharge: 0
        }
      ]);
    };
    return (
      <>
        <Popup onClose={closeModal}>
          <ModalRateCardRuleComponent
            Close={closeModal}
            addTaxonomyRow={addTaxonomyRow}
            taxonomy={localTaxonomyItems}
            removeTaxonomy={removeTaxonomy}
            handleFormItemChange={handleTaxonomyFormChange}
            vehicleList={vehiclesListItems?.result?.items}
            vehicleBodyTypes={libraryData?.result?.VehicleBodyType}
            selectedRateCardValues={selectedRateCardValues}
            vehicleCategories={vehicleCategoriesListItems?.result?.items}
            Logisticss={queryItems?.result?.items?.Logisticss}
            messageDelayPeriod={libraryData?.result?.MessageDelayPeriod}
            weights={measureWeightLists?.result?.items}
            distances={measureDimensionsLists?.result?.items}
            selectedRateCards={selectedRateCards}
            shippingTypes={shippingTypesLists?.result?.items}
            shipmentTypePreference={libraryData?.result?.ShipmentTypePreference}
            handleItemSubmit={handleItemSubmit}
            selectLogistics={localItems}
            onInnerBasicFormChange={handleLocalFormChange}

          />

        </Popup>
      </>
    )
  }

  // Submit the RateCard Function
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const logisticsItemsData: any = selectedRateCardValues.map((item: any) => {
      const itemData = {
        Id: item?.Id || 0,
        EntityTypeId: 152,
        EntityId: selectedRateCards?.LogisticsProviderId,
        ShippingTypeId: item?.ShippingTypeId,
        AverageDeliveryTime: item?.AverageDeliveryTime,
        ShippingTypePreferenceId: item?.ShippingTypePreferenceId,
        Name: item?.Name,
        PINCode: { PinCode: selectedRateCards.PINCode },
        TimeSlot: {
          DurationUnitId: item?.DurationUnitId,
          Duration: item?.Duration,
          DurationIncrement: item?.DurationIncrement,
          PickupTimeSlots: item?.PickupTimeSlots,
          DeliveryTimeSlots: item?.DeliveryTimeSlots

        },
        Shipping: {
          MinimunDistance: item?.MinimunDistance,
          MaximumDistance: item?.MaximumDistance,
          DistanceUnitId: item?.DistanceUnitId,
          MinimumWeight: item?.MinimumWeight,
          MaximumWeight: item?.MaximumWeight,
          WeightUnitId: item?.WeightUnitId,
          PackageSizeUnit: item?.PackageSizeUnit,
          MinimumHeight: item?.MinimumHeight,
          MaximumHeight: item?.MaximumHeight,
          MinimumLength: item?.MinimumLength,
          MaximumLength: item?.MaximumLength,
          MinimumBreadth: item?.MinimumBreadth,
          MaximumBreadth: item?.MaximumBreadth,
          DistanceIncrement: item?.DistanceIncrement,
          DistanceIncrementCharge: item?.DistanceIncrementCharge,
          WeightIncrement: item?.WeightIncrement,
          WeightIncrementCharge: item?.WeightIncrementCharge,
          DeliveryCharge: item?.DeliveryCharge,
          FuelCharge: item?.FuelCharge,
          WaitingCharge: item?.WaitingCharge,
          PeakSeasonCharge: item?.PeakSeasonCharge,
          TollCharge: item?.TollCharge,
          RTOCharge: item?.RTOCharge,
          IsIncludeVehicleAmount: item?.IsIncludeVehicleAmount,
          LogisticsCategoryVehicleDistanceInfo: item?.LogisticsCategoryVehicleDistanceInfo
        }
      }
      return itemData
    })
    const rateData = {
      "Id": selectedRateCards?.Id || 0,
      "IsActive": selectedRateCards?.IsActive,
      "Name": selectedRateCards?.Name,
      "Description": selectedRateCards?.Description,
      "LogisticsProviderId": selectedRateCards?.LogisticsProviderId,
      "LogisticsOrderType": selectedRateCards?.LogisticsOrderType,
      "StartDateUtc": selectedRateCards?.StartDateUtc,
      "EndDateUtc": selectedRateCards?.EndDateUtc,
      "Remarks": selectedRateCards?.Remarks,
      "DisplayOrder": selectedRateCards?.DisplayOrder,
      "Inclusions": selectedRateCards?.Inclusions || [],
      "Exclusions": selectedRateCards?.Exclusions || [],
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": [

        ]
      },
      "Logisticss": logisticsItemsData
    }
    if (parmas?.id > 0) {
      await dispatch(rateCards.resetAction({ actionType: 'update' }))
      await dispatch(rateCards.update({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/rate-cards`, entity: 'rateCards', jsonData: {
          Context: {},
          Records: [
            rateData
          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(rateCards.resetAction({ actionType: 'create' }))
      await dispatch(rateCards.create({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/shipment/rate-cards`, entity: 'rateCards', jsonData: {

          Context: {},
          Records: [
            rateData
          ]

        }
      })).then(() => {
        back()
      })

    }

  }

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {
        addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
      }
      {isLoading ? <PageLoader /> :


        <RateCardComponent
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedRateCards={selectedRateCards}
          fileTypes={libraryData?.result?.FileType}
          shippingProviders={shippingProvidersLists?.result?.items}
          allTags={tagsLists?.result?.items}
          back={back}
          onInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          handleFormMediaItemChange={handleFormMediaItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          id={parmas?.id}
          customers={customerLists?.result?.items}
          selectedRateCardValues={selectedRateCardValues}
          pinCodes={pinCodesLists?.result?.items}
          columnDefs={columnDefs}
          handleEdit={handleEdit}
          additionButtons={additionButtons}
          handleDelete={handleDelete}
        />
      }

    </>
  )

}

export default RateCard;